import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { getTextWithHighlight } from '@/pages/intelligence/utils/commonUtils';
import { isEmpty, getEarlistedReleaseTime, getReleaseTime } from '../../../../utils';
import './index.scss';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { useIntl } from 'umi';
import { formatReleaseTime } from "@home/components/NavHeader/sreachContext/utils";
import { formatDateStr } from '@intelligence/utils/dateUtils';

export default function EntityRenderer(tablePayload: any, keyword = '', hasShortCut = false, showEntity = true, hasReleaseTime = true) {
  // 中英翻译
  const { locale, formatMessage } = useIntl();
  const payload = tablePayload?.cvm;
  if (isEmpty(payload)) return null;
  const { typeIdList = [], entityType = '', entity_type: entityTypeOther = '' } = payload;
  const entityTypeCur = entityType || entityTypeOther || '';

  let entityTypeTemp = '';
  if (Array.isArray(typeIdList) && typeIdList?.length > 0) {
    entityTypeTemp = typeIdList?.map((item: any) => item.type)?.join(',');
  } else {
    entityTypeTemp = entityTypeCur?.toLowerCase() || '';
  }
  const publisher = payload?.publisher || '';
  const isMobile = entityTypeTemp?.includes('mobile');
  const isPC = entityTypeTemp?.includes('pc');
  const isConsole = entityTypeTemp?.includes('console');
  const isCombine = entityTypeTemp?.includes('combine');
  const releaseTime = getEarlistedReleaseTime(payload) || formatReleaseTime(locale, {
    isSpecialReleaseTime: payload?.is_special_release_time,
    releaseTime: payload?.releaseTime,
    releaseTimeEN: payload?.release_time_en,
    releaseTimeCN: payload?.release_time_cn,
  }, '') || payload?.release_time;
  const gameNameCur = payload?.gameName || payload?.name || payload?.entity_name;
  const highlightGameTitleNode = getTextWithHighlight(gameNameCur?.trim(), keyword);

  const entityNode = (
    <>
      {isMobile && (
        <SvgIcon className="dbi-add-entities-first-row-comp_platform-icon" type="other-icon" />
      )}
      {isPC && (
        <SvgIcon className="dbi-add-entities-first-row-comp_platform-icon" type="monitor" />
      )}
      {isConsole && (
        <SvgIcon
          className="dbi-add-entities-first-row-comp_platform-icon dbi-add-entities-first-row-comp_platform-console-icon"
          type="game"
          style={{ fontSize: '13px' }}
        />
      )}
      {isCombine && (
        <SvgIcon
          className="dbi-add-entities-first-row-comp_platform-icon"
          type="pc-console-combine"
        />
      )}
    </>
  );

  // 扩展hasReleaseTime，如果不需要上线时间，则把游戏对应的类型放到下一行
  const gameTitleNode = (
    <div className="dbi-add-entities-first-row-comp">
      <div className="dbi-add-entities-first-row-comp_title">
        <EllipsisHover text={highlightGameTitleNode || '-'} textBubble={gameNameCur} />
      </div>
      {((hasShortCut && !showEntity) || !hasReleaseTime) ? null : entityNode}
    </div>
  );
  const cvm: any = {
    gametitle: gameTitleNode,
    img: payload?.cover || '',
    text: releaseTime ? `${formatMessage({ id: 'dbi_release' })} ${formatDateStr(releaseTime)}` : '',
    tipList: publisher ? [publisher] : [],
    gameEntityNode: entityNode
  };

  const getPlatform = (isPC: boolean, isConsole: boolean) => {
    if (Array.isArray(typeIdList) && typeIdList?.length > 0) return entityTypeCur;
    if (isPC && isConsole) return PC_CONSOLE_COMBINE_ENTITY_TYPE;
    if (isPC) return 'pc';
    if (isConsole) return 'console';
    return 'pc';
  };

  // @ts-ignore
  return (
    <FirstRow
      cvm={cvm}
      className={'allgame-selector-firstrow'}
      // pc console的搜索没有分开id返回（如要做需要后端返回），暂时不做跳转，看做了融合id详情页面后再增加跳转
      rihgtClickToJumpHref={getDetailGameOverviewPath(
        payload?.app_id || payload?.gameId,
        getPlatform(isPC, isConsole),
      )}
      hasReleaseTime={hasReleaseTime}
    />
  );
}
